import isNumber from 'lodash/isNumber';

export function getDecimals(number) {
    return Math.abs(number) < 1 ? 3 : 2;
}

export function formatNumber(number, decimals = 2, isPct = false) {
    if (!isNumber(number)) {
        return '-';
    }

    const pct = isPct ? '%' : '';

    return number.toFixed(decimals)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        .replace('.', ',') + pct;
}

export function formatLargeNumber(number, decimals) {
    const abs = Math.abs(number);

    if (abs >= 1e9) {
        return `${formatNumber(number / 1e9, decimals)} md.`;
    } else if (abs >= 1e6) {
        return `${formatNumber(number / 1e6, decimals)} mn.`;
    }

    return formatNumber(number, decimals);
}

export function padDecimals(number) {
    const decimals = number.toString().split('.')[1];

    const fixedDecimals = (!decimals || decimals.length < 2)
        ? 2 : decimals.length;

    return number.toFixed(fixedDecimals).toString().replace('.', ',');
}

export function pad(number, width, paddingSymbol = '0') {
    const numberLength = number.toString().length || 0;

    if (numberLength >= width) {
        return number;
    }

    const padding = new Array(width - numberLength + 1).join(paddingSymbol);

    return `${padding}${number}`;
}



/** WEBPACK FOOTER **
 ** /src/shared/service/market.js
 **/